import { Component, HostListener, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MenuItem } from '../../models/menu-item.class';
import { menu } from '../../utils/menu';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MatIconModule, RouterModule, MatDividerModule, CommonModule, MatTooltipModule],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  @Input() collapsed = false;
  @Input() mobileSidebarOpen = false;
  AuthService = inject(AuthService);

  items: MenuItem[] = menu;

  get collapsedItems(): MenuItem[] {
    return this.items.flatMap((item) => {
      if (item.heading) {
        return item.subItems ?? [];
      }

      return [item];
    });
  }

  contactUs: MenuItem = {
    text: 'Kontakt oss',
    link: '/kontakt-oss',
  };

  // admin: MenuItem = {
  //   text: 'Admin',
  //   link: '/admin',
  // };

  userProfile: MenuItem = {
    text: 'Min Profil',
    link: '/min-profil',
  };

  logOut: MenuItem = {
    text: 'Logg ut',
  };

  ngOnInit() {
    this.checkScreenSize(); // sjekk en gang ved oppstart
  }

  @HostListener('window:resize')
  onResize() {
    this.checkScreenSize();
  }

  logout() {
    this.AuthService.logout();
  }

  toggleSection(item: MenuItem, event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    if (!item.heading) {
      return;
    }

    item.subMenuOpen = !(item.subMenuOpen ?? true);
  }

  private checkScreenSize() {
    if (window.innerWidth <= 950) {
      this.collapsed = true;
    } else {
      this.collapsed = false;
    }
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }
}
